import React from "react";
import { ACTION_ADD_TOUR } from "../constant/Constant";

export const handleChange = (data) => async (dispatch) => {
  dispatch({
    type: ACTION_ADD_TOUR,
    payload: data,
  });
};
